import { render } from "./ScheduleTestDrive.vue?vue&type=template&id=a899e2ea&lang=true"
import script from "./ScheduleTestDrive.vue?vue&type=script&lang=js"
export * from "./ScheduleTestDrive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/AssistantAi/StartUpIcons/ScheduleTestDrive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a899e2ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a899e2ea', __exports__)) {
    api.reload('a899e2ea', __exports__)
  }
  
  module.hot.accept("./ScheduleTestDrive.vue?vue&type=template&id=a899e2ea&lang=true", () => {
    api.rerender('a899e2ea', render)
  })

}


export default __exports__